module.exports = __webpack_public_path__ + "static/media/bg-5.cf607f61.jpg";